import { JobStatus } from 'model/JobStatus';

export const ImportSurveyAnswerQueueName = 'import_answers';

export type QueueApiError = {
  message: string;
  code: string;
  path: string;
};

export type QueueDto = {
  id: number;
  name: string;
  status: number;
  projectId: number;
  progress?: number;
  reason?: (string | QueueApiError)[];
};

export type QueueModel = {
  id: number;
  name: string;
  progress: number;
  status: JobStatus;
  projectId: number;
  reason?: (string | QueueApiError)[];
};

export function mapQueueDtoToModel(dto: QueueDto): QueueModel {
  return {
    id: dto.id,
    name: dto.name,
    status: dto.status,
    reason: dto.reason,
    projectId: dto.projectId,
    progress: dto.progress || 0,
  };
}
